import React from "react";
import { Card, CardContent } from "../../ui/card";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";
import { Loader2Icon } from "lucide-react";

interface CustomCriteriaFormProps {
  customName: string;
  setCustomName: (v: string) => void;
  customInstructions: string;
  setCustomInstructions: (v: string) => void;
  customScoringType: "numeric" | "boolean";
  onScoringTypeChange: (type: "numeric" | "boolean") => void;
  editingCriteriaId: number | null;
  loading: boolean;
  onSave: () => void;
  onCancel: () => void;
}

const CustomCriteriaForm: React.FC<CustomCriteriaFormProps> = ({
  customName,
  setCustomName,
  customInstructions,
  setCustomInstructions,
  customScoringType,
  onScoringTypeChange,
  editingCriteriaId,
  loading,
  onSave,
  onCancel,
}) => {
  return (
    <Card className="border-dashed border-border">
      <CardContent className="p-4 space-y-3">
        <Input
          placeholder="Criterion name"
          value={customName}
          onChange={(e) => setCustomName(e.target.value)}
          className="text-sm"
        />
        <div className="flex gap-1 p-0.5 bg-muted rounded-md w-fit">
          <button
            onClick={() => onScoringTypeChange("numeric")}
            className={`px-3 py-1 text-xs rounded transition-colors ${
              customScoringType === "numeric"
                ? "bg-background text-foreground font-gc-med shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            Numeric (1–5)
          </button>
          <button
            onClick={() => onScoringTypeChange("boolean")}
            className={`px-3 py-1 text-xs rounded transition-colors ${
              customScoringType === "boolean"
                ? "bg-background text-foreground font-gc-med shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            Pass / Fail
          </button>
        </div>
        <textarea
          placeholder={
            customScoringType === "boolean"
              ? "Describe what constitutes a pass or fail…"
              : "Describe the criterion, then fill in each score level…"
          }
          value={customInstructions}
          onChange={(e) => setCustomInstructions(e.target.value)}
          className="w-full min-h-[140px] p-2 text-sm border border-border rounded-md bg-background resize-y font-mono leading-relaxed"
        />
        <div className="flex gap-2">
          <Button
            size="sm"
            onClick={onSave}
            disabled={
              !customName.trim() || !customInstructions.trim() || loading
            }
          >
            {loading ? (
              <Loader2Icon className="w-3 h-3 animate-spin" />
            ) : editingCriteriaId ? (
              "Update"
            ) : (
              "Save"
            )}
          </Button>
          <Button size="sm" variant="ghost" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomCriteriaForm;
